module.exports = __webpack_public_path__ + "1ccd96bf8195dfeea4be7467bccad658.pdf";